import React from 'react';
import { Link } from 'react-router-dom';

function Education() {
  return (
    <div className="container mt-5">
      <div className="row align-items-center">

        {/* Image Section */}
        <div className="col-12 col-md-6 text-center mb-4 mb-md-0">
          <img
            src="media/education.svg"
            alt="Education"
            className="img-fluid"
            style={{ maxWidth: "90%" }}
          />
        </div>

        {/* Content Section */}
        <div className="col-12 col-md-6 text-center text-md-start">
          <h1 className="mb-3">
            Free and open market education
          </h1>

          <p>
            Varsity, the largest online stock market education book in the world
            covering everything from the basics to advanced trading.
          </p>

          <Link
            to="/varsity"
            style={{ textDecoration: "none" }}
          >
            Varsity →
          </Link>

          <p className="mt-4">
            TradingQ&A, the most active trading and investment community in
            India for all your market related queries.
          </p>

          <Link
            to="/tradingqa"
            style={{ textDecoration: "none" }}
          >
            TradingQ&A →
          </Link>
        </div>

      </div>
    </div>
  );
}

export default Education;